import React from 'react'

import { ReactComponent as HeaderTelegram } from '../assets/svg/Header/HeaderTelegram.svg'
import { ReactComponent as HeaderWhatsApp } from '../assets/svg/Header/HeaderWhatsApp.svg'
import { ReactComponent as CristmasThree } from '../assets/svg/Header/cristmasthree.svg'
import { ReactComponent as Darts } from '../assets/svg/Header/darts.svg'



export const results = [
  {
    link: '2025',
    name: '2025',
    icon: <CristmasThree width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
  {
    link: '2026',
    name: '2026',
    icon: <Darts width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  }
]
